import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch as RouterSwitch } from 'react-router-dom'
import { Button, Modal, Space, Switch, Table, Empty } from 'antd'
import PageLoader from '../../../components/Layouts/PageLoader'
import PrivateRoute from '../../../hocs/PrivateRoute'
import PaginationContainer from '../../../components/Forms/Pagination'
import { getRequest, formatUrl, shippingFeesUrl } from '../../../config'
import { columns } from './tableColumns'
import ShippingFeeForm from './ShippingFeeForm'

const ShippingFeesList = () => {
  const [loading, setLoading] = useState(false)
  const [fees, setFees] = useState([])
  const [meta, setMeta] = useState({ previous: null, next: null, count: 0 })
  const [onlyFlagged, setOnlyFlagged] = useState(true)
  const [currentRecord, setCurrentRecord] = useState(null)
  const [showFormModal, setShowFormModal] = useState(false)
  const [modalKey, setModalKey] = useState(0)

  // The "Flagged only" toggle is sent to the server (?flagged=true) so it filters across the
  // whole dataset rather than just the loaded page. `url` is a paginator next/previous link.
  const getFees = async (flagged = onlyFlagged, url = null) => {
    const response = await getRequest(
      url ? formatUrl(url) : `${shippingFeesUrl}${flagged ? '?flagged=true' : ''}`,
      'shipping fees',
      setLoading
    )
    if (response.success) {
      setFees(response.data.results || response.data)
      setMeta({ ...response.data })
    }
  }

  const handleFlaggedToggle = checked => {
    setOnlyFlagged(checked)
    getFees(checked)
  }

  useEffect(() => {
    getFees()
    // eslint-disable-next-line
  }, [])

  const openEdit = record => {
    setCurrentRecord(record)
    setModalKey(k => k + 1)
    setShowFormModal(true)
  }

  const handleDone = () => {
    setShowFormModal(false)
    getFees()
  }

  return (
    <PageLoader className="container" loading={loading}>
      <div className="card mb-5rem">
        <div className="card-body">
          <h3 style={{ marginBottom: 16 }}>
            Shipping Fees {meta && `(${meta.count})`}
          </h3>
          <div style={{ marginBottom: 16 }}>
            <Space>
              <Button onClick={() => getFees()}>Refresh</Button>
              <span>
                <Switch checked={onlyFlagged} onChange={handleFlaggedToggle} />{' '}
                Flagged only
              </span>
            </Space>
            <p style={{ marginTop: 8, color: '#888' }}>
              Freight + insurance per origin and body type. The WhatsApp assistant
              auto-estimates these for new markets and flags them for review — verify the
              amounts and turn off the flag once confirmed.
            </p>
          </div>

          <Table
            rowKey="id"
            dataSource={fees}
            columns={columns(openEdit)}
            scroll={{ x: 900 }}
            pagination={false}
            locale={{
              emptyText: (
                <Empty
                  description={
                    onlyFlagged ? 'No fees need review' : 'No shipping fees yet'
                  }
                />
              )
            }}
          />
          {fees.length ? (
            <PaginationContainer
              meta={meta}
              getData={url => getFees(onlyFlagged, url)}
            />
          ) : null}
        </div>
      </div>

      <Modal
        title="Edit Shipping Fee"
        centered
        open={showFormModal}
        onCancel={() => setShowFormModal(false)}
        footer={null}
        width={560}
      >
        <ShippingFeeForm
          key={modalKey}
          record={currentRecord}
          handleDone={handleDone}
        />
      </Modal>
    </PageLoader>
  )
}

const ShippingFeesRoutes = props => (
  <RouterSwitch>
    <PrivateRoute exact path={props.match.path} component={ShippingFeesList} />
  </RouterSwitch>
)

ShippingFeesRoutes.propTypes = {
  match: PropTypes.object
}

export default withRouter(ShippingFeesRoutes)
